import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  requestChangeMember,
  changeCompanyModal,
} from "../../../../../redux/actions/company";
import { TransparentButton, SolidButton } from "../../../../library/button";
import { Label } from "../../../../library/label";
import { Popup } from "../../../../library/popup";
import { Select } from "../../../../library/select";

import "./style.scss";

const Index = () => {
  const dispatch = useDispatch();

  const [userRole, setUserRole] = useState(null);

  const modalState = useSelector(
    (state) => state.company.showModals.changeModal
  );
  const member = useSelector((state) => state.company.activeEdit);
  const companyId = useSelector((state) => state.company?.details?.id);

  const loading = useSelector((state) => state.company?.deleteMember.loading);

  const handleClose = () => {
    dispatch(changeCompanyModal({ changeModal: false }));
  };

  const clickChangeMember = () => {
    dispatch(
      requestChangeMember({
        id: member?.id,
        role: userRole,
        companyId: companyId,
      })
    );
  };

  const roles = ["administrator", "standard"];

  const format_role = (role) => {
    switch (role) {
      case "administrator":
        return "Administrator";
      case "standard":
        return "Standard";
      default:
        return "Standard";
    }
  };

  const renderRoles = () => {
    const selections = [];
    selections.push({
      id: 0,
      value: member.role,
      title: format_role(member.role),
      selected: true,
    });
    roles
      .filter((role) => role !== member?.role)
      .map((single, index) => {
        selections.push({
          id: index + 1,
          value: single,
          title: format_role(single),
          selected: false,
        });
      });
    return selections;
  };

  return (
    <Popup
      onClose={handleClose}
      show={modalState}
      title="Oppdater bruker"
      buttons={[
        <TransparentButton
          title="Avbryt"
          type="button"
          data-dismiss="modal"
          onClick={() => handleClose()}
        />,
        <SolidButton
          color="blue"
          title={loading ? "Oppdaterer.." : "Oppdater"}
          icon={
            loading ? <i className="fas fa-circle-notch fa-spin"></i> : null
          }
          onClick={() => clickChangeMember()}
          type="button"
        />,
      ]}
    >
      <div className="change-member-content-container">
        <Row className="info-row">
          <Col className="info-col">
            <Label version={1} weight="bold">
              Rolle
            </Label>
            <Select
              onChange={(e) => setUserRole(e.target.value)}
              items={renderRoles()}
            />
          </Col>
        </Row>
      </div>
    </Popup>
  );
};

export default Index;
